import { Component, OnInit, OnDestroy } from '@angular/core'; // Додаємо OnInit та OnDestroy
import { FiltersService } from '../../services/filters.service';
import { Subscription } from 'rxjs'; // Для керування підпискою

@Component({
  selector: 'filter-radio-block',
  templateUrl: './filter-radio-block.component.html',
  styleUrls: ['./filter-radio-block.component.sass']
})
export class FilterRadioBlockComponent implements OnInit, OnDestroy {

  selectedFreight: string = 'shippedFreightAll';
  private freightSubscription: Subscription;

  constructor(private filtersService: FiltersService) {}

  ngOnInit() {
    // Підписуємося на зміни в сервісі
    // Коли AppComponent або інший сервіс змінить значення, ми оновимо змінну в цьому компоненті
    this.freightSubscription = this.filtersService.getSelectedFreight$()
      .subscribe(value => {
        if (value) {
          this.selectedFreight = value;
        }
      });
  }

  onFilterChange() {
    this.filtersService.clearAllFilters();
    this.filtersService.setFilterState(this.selectedFreight, true);
    this.filtersService.setSelectedFreight(this.selectedFreight);
  }

  ngOnDestroy() {
    // Важливо відписатися при знищенні компонента, щоб не було витоку пам'яті
    if (this.freightSubscription) {
      this.freightSubscription.unsubscribe();
    }
  }
}